import { PipeTransform } from '@angular/core';
import type { GenEnum } from '@bufbuild/protobuf/codegenv2';
import { enumLabel } from '@vmspdb/definitions';

export abstract class AbstractEnumPipe implements PipeTransform {
  abstract readonly enum: GenEnum<number, string>;

  transform(value: number | string | undefined): string {
    if (value === undefined) {
      return '';
    }

    return enumLabel(this.enum, value);
  }
}
